export default __webpack_public_path__ + "static/media/bg_6.7e9cbbea.png";